
ngDatetimeFormat.$inject = ['datetimePlaceholder'];
export function ngDatetimeFormat(datetimePlaceholder){

    datetimePlaceholder.year = "yyyy";
    datetimePlaceholder.month = "mm";
    datetimePlaceholder.date = "dd";

}


// WEBPACK FOOTER //
// ./resources/assets/js/config/datetimeFormat.config.ts